(function () {
  if (window.__cartConsentGlobalInit) return;
  window.__cartConsentGlobalInit = true;

  function syncCheckoutButton() {
    var checkbox = document.getElementById('Cart-Consent');
    var checkoutBtn = document.getElementById('checkout');

    if (!checkoutBtn) return;

    if (checkbox) {
      if (checkbox.checked) {
        checkoutBtn.disabled = false;
        checkoutBtn.removeAttribute('disabled');
      } else {
        checkoutBtn.disabled = true;
        checkoutBtn.setAttribute('disabled', 'disabled');
      }
      return;
    }
  }

  function syncCheckoutButtonDelayed() {
    syncCheckoutButton();
    setTimeout(syncCheckoutButton, 50);
    setTimeout(syncCheckoutButton, 150);
    setTimeout(syncCheckoutButton, 300);
  }

  document.addEventListener('change', function (event) {
    if (!event.target || event.target.id !== 'Cart-Consent') return;

    syncCheckoutButtonDelayed();

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          consent: event.target.checked ? 'true' : ''
        }
      })
    }).then(function () {
      syncCheckoutButtonDelayed();
    }).catch(function () {
      syncCheckoutButtonDelayed();
    });
  });

  var observer = new MutationObserver(function () {
    syncCheckoutButtonDelayed();
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncCheckoutButtonDelayed();
  });

  syncCheckoutButtonDelayed();
})();